<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/demandHome/demandOrder' }">我的订单</el-breadcrumb-item>
			  <el-breadcrumb-item>订单详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button" @click="fanhui" style="cursor:pointer;">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<div class="container">
			<div class="leftsidebar">
				<div class="leftsidebarTitle">
					<h3>{{datails.demand.name}}</h3>
					<p>订单编号：{{datails.order_sn}}</p>
				</div>
				<div class="leftsidebarDox">
					<div class="leftsidebarDox1">
						<h3>需求方</h3>
						<div class="leftsidebarDox1_1">
							<img :src="datails.demandUser.avatar" alt="" srcset="" />
							<div>{{datails.demandUser.nickname}}</div>
						</div>
					</div>
					<div class="leftsidebarDox2">
						<h3>订单金额</h3>
						<div>
							￥{{datails.total_price}}
						</div>
					</div>
					<div class="leftsidebarDox1">
						<h3>服务方</h3>
						<div class="leftsidebarDox1_1">
							<img :src="datails.serveUser.avatar" alt="" srcset="" />
							<div>{{datails.serveUser.nickname}}</div>
						</div>
					</div>
				</div>
				<div class="leftsidebarTitle"  v-if="datails.status==-1 || datails.status==-2">
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间">{{datails.create_time}}</el-descriptions-item>
					    <el-descriptions-item label="支付时间" v-if="datails.status==-2">{{datails.pay_time*1000 | dateFormat}}</el-descriptions-item>
						<el-descriptions-item label="取消时间" v-if="datails.status==-1">
						         {{datails.cancel_time*1000 | dateFormat}}
						</el-descriptions-item>
					    <el-descriptions-item label="支付方式" v-if="datails.status==-2 && datails.pay_type=='JSAPI'">
							微信支付
						</el-descriptions-item>
						<el-descriptions-item label="支付方式" v-if="datails.status==-2 && datails.pay_type=='NATIVE'">
							扫码支付
						</el-descriptions-item>
					    <el-descriptions-item label="退款时间" v-if="datails.status==-2">
							{{datails.refund_time*1000 | dateFormat}}
						</el-descriptions-item>
						<el-descriptions-item label="退款阶段" v-if="datails.refund_stage==1">
							   承认图
						</el-descriptions-item>
						<el-descriptions-item label="退款阶段" v-if="datails.refund_stage==2">
							   生产图
						</el-descriptions-item>
						<el-descriptions-item label="订单退款金额" v-if="datails.status==-2">￥{{datails.total_price}}</el-descriptions-item>
					</el-descriptions>
					<div class="leftsidebarButton" v-if="datails.status == -2 &&  datails.message_count>0">
						<div @click="liuyan(datails.o_id,datails.status)" class="leftsidebar2">查看留言</div>
					</div>
				</div>
				<div class="leftsidebarTitle"  v-if="datails.status==0">
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间">{{datails.create_time}}</el-descriptions-item>
					</el-descriptions>
					<div class="leftsidebarButton">
						<div @click="pay" class="leftsidebar2">立即支付</div>
					</div>
				</div>
				<div class="leftsidebarTitle"  v-if="datails.status==1 || datails.status==2 || datails.status==3 || datails.status==4 || datails.status==5">
					<el-descriptions title="订单信息" :column="2">
					    <el-descriptions-item label="中标时间">{{datails.create_time}}</el-descriptions-item>
						<el-descriptions-item label="支付方式" v-if="datails.pay_type=='JSAPI'">
							微信支付
						</el-descriptions-item>
						<el-descriptions-item label="支付方式" v-if="datails.pay_type=='NATIVE'">
							扫码支付
						</el-descriptions-item>
						<el-descriptions-item label="支付时间">{{datails.pay_time*1000 | dateFormat}}</el-descriptions-item>
						
						<el-descriptions-item label="承认图验收时间" 
						    v-if="datails.status==3 || datails.status==4 || datails.status==5">
							{{datails.stageOne.confirm_time*1000 | dateFormat}}
						</el-descriptions-item>
						<el-descriptions-item label="生产图验收时间" 
						     v-if="datails.status==5 && datails.stageTwo.confirm_time>0">
							{{datails.stageTwo.confirm_time*1000 | dateFormat}}
						</el-descriptions-item>
						
						<el-descriptions-item label="生产图验收状态"
						     v-if="datails.status==5 && datails.stageTwo.status==-2">
							 已退款
						</el-descriptions-item>
						<el-descriptions-item label="生产图退款金额"
						     v-if="datails.status==5 && datails.stageTwo.status==-2">
							￥{{datails.stageTwo.refund_price}}
						</el-descriptions-item>
						<el-descriptions-item label="生产图退款时间"
						     v-if="datails.status==5 && datails.stageTwo.status==-2">
							{{datails.stageTwo.refund_time*1000 | dateFormat}}
						</el-descriptions-item>
					</el-descriptions>
					<!-- 承认图 未发起评审 -->
					<div class="leftsidebarButton" v-if="datails.status==1 ">
						<el-badge class="item" :is-dot="datails.unread_message_count>0" @click="liuyan(datails.o_id,datails.status)">
						    <div class="leftsidebar2" @click="liuyan(datails.o_id,datails.status)"  >留言</div>
						</el-badge>
					</div>
					<div class="leftsidebarButton" v-if="datails.status==2  && !datails.stageOne.review">
						<div @click="addpshen" class="leftsidebar2">发起评审</div>
						<div @click="yanshou" class="leftsidebar2">确认验收</div>
						<el-badge class="item" :is-dot="datails.unread_message_count>0">
						    <div @click="liuyan(datails.o_id,datails.status)" class="leftsidebar2">留言</div>
						</el-badge>
					</div>
					<!-- 承认图 已发起评审 -->
					<div class="leftsidebarButton" v-if="datails.status==2  && datails.stageOne.review">
						<el-badge class="item" :is-dot="datails.unread_message_count>0">
							<div class="canli leftsidebar2" @click="liuyan(datails.o_id,datails.status)">留言</div>
						</el-badge>
					</div>
					<!-- 生产图待确定 承认图发起评审 -->
					<div class="leftsidebarButton" v-if="datails.status==3  && !datails.stageTwo.review">
						<el-badge class="item" :is-dot="datails.unread_message_count>0">
							<div  @click="liuyan(datails.o_id,datails.status)" class="leftsidebar2">留言</div>
						</el-badge>
					</div>
					<div class="leftsidebarButton" v-if="datails.status==4  && !datails.stageTwo.review">
						<div @click="addpshen" class="leftsidebar2">发起评审</div>
						<div @click="yanshou" class="leftsidebar2">确认验收</div>
						<el-badge class="item" :is-dot="datails.unread_message_count>0">
							<div @click="liuyan(datails.o_id,datails.status)" class="leftsidebar2">留言</div>
						</el-badge>
					</div>
					<div class="leftsidebarButton" v-if="datails.status==4  && datails.stageTwo.review">
						<el-badge class="item" :is-dot="datails.unread_message_count>0">
							<div @click="liuyan(datails.o_id,datails.status)" class="leftsidebar2">留言</div>
						</el-badge>
					</div>
					
					<div class="leftsidebarButton" v-if="datails.status==5  && datails.is_invoice>0 && datails.message_count>0">
						<div @click="liuyan(datails.o_id,datails.status)" class="leftsidebar2">查看留言</div>
						<div @click="chakana(datails.o_id)" class="leftsidebar2">查看开票</div>
					</div>
					<div class="leftsidebarButton" v-if="datails.status==5  && datails.is_invoice==0 && datails.message_count>0">
						<div @click="liuyan(datails.o_id,datails.status)" class="leftsidebar2">查看留言</div>
						<div @click="kaipiao(datails.o_id)" class="leftsidebar2">开票</div>
					</div>
					<div class="leftsidebarButton" v-if="datails.status==5  && datails.is_invoice>0 && datails.message_count==0">
						<div @click="chakana(datails.o_id)" class="leftsidebar2">查看开票</div>
					</div>
				</div>
				
				
				<div class="leftsidebarTitle" v-if="datails.stageOne && datails.stageOne.review">
					<el-descriptions title="评审信息（承认图）" :column="2">
					    <el-descriptions-item label="评审金支付时间">
						     {{datails.stageOne.review.pay_time*1000 | dateFormat}}
						</el-descriptions-item>
					    <el-descriptions-item label="评审金金额">￥{{datails.stageOne.review.total_price}}</el-descriptions-item>
					    <el-descriptions-item label="支付方式">{{datails.stageOne.review.pay_type_text}}</el-descriptions-item>
					    <el-descriptions-item label="评审参与人数">
						   {{datails.stageOne.review.review_num}}人
						</el-descriptions-item>
						<el-descriptions-item label="已参与评审人数">
						   {{datails.stageOne.review.reviewed_count}}人
						</el-descriptions-item>
						<el-descriptions-item label="评审金退款金额">
							￥{{datails.stageOne.review.refund_price}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="leftsidebarButton">
						<div @click="chakan" class="leftsidebar2">查看评审结果</div>
					</div>
				</div>

				<div class="leftsidebarTitle" v-if="datails.stageTwo && datails.stageTwo.review">
					<el-descriptions title="评审信息（生产图）" :column="2">
					    <el-descriptions-item label="评审金支付时间">
						    {{datails.stageTwo.review.pay_time*1000 | dateFormat}}
						</el-descriptions-item>
					    <el-descriptions-item label="评审金金额">
							￥{{datails.stageTwo.review.total_price}}
						</el-descriptions-item>
					    <el-descriptions-item label="支付方式">{{datails.stageTwo.review.pay_type_text}}</el-descriptions-item>
					    <el-descriptions-item label="评审参与人数">{{datails.stageTwo.review.review_num}}人</el-descriptions-item>
						<el-descriptions-item label="已参与评审人数">
						  {{datails.stageTwo.review.reviewed_count}}人
						</el-descriptions-item>
						<el-descriptions-item label="评审金退款金额">
						  ￥{{datails.stageTwo.review.refund_price}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="leftsidebarButton">
						<div @click="chakan" class="leftsidebar2">查看评审结果</div>
					</div>
				</div>
				
			</div>
			<div class="rightsidebar">
				<div class="rightsidebar1" v-if="datails.status==1">
					<h3>待上传承认图</h3>
					<p>交付剩余时间：<CountDown :endTime="datails.stageOne.upload_countdown*1000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==-1">
					<h3>已取消</h3>
					<p>订单已取消，您可查看其他订单</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==-2">
					<h3>已退款</h3>
					<p>支付金额原路退回</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==0">
					<h3>待支付</h3>
					<p>剩余支付时间：<CountDown :endTime="datails.auto_cancel_time*1000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==2 && !datails.stageOne.review">
					<h3>承认图待验收</h3>
					<p>剩余自动确认时间：<CountDown :endTime="datails.stageOne.auto_confirm_time*1000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==2 && datails.stageOne.review">
					<h3>承认图待验收</h3>
					<p>评审中，请您耐心等待</p>
				</div>
				
				<div class="rightsidebar1" v-if="datails.status==3">
					<h3>待上传生产图</h3>
					<p>剩余交付时间：<CountDown :endTime="datails.stageTwo.upload_countdown*1000"></CountDown></p>
				</div>
				
				
				<div class="rightsidebar1" v-if="datails.status==4 && !datails.stageTwo.review">
					<h3>生产图待验收</h3>
					<p>剩余自动确认时间：<CountDown :endTime="datails.stageTwo.auto_confirm_time*1000"></CountDown></p>
				</div>
				
				<div class="rightsidebar1" v-if="datails.status==4 && datails.stageTwo.review">
					<h3>生产图待验收</h3>
					<p>评审中，请您耐心等待</p>
				</div>
				
				
				<div class="rightsidebar1" v-if="datails.status==5">
					<h3>已完成</h3>
					<p>感谢您使用本平台</p>
				</div>
				<div class="rightsidebar2">
					<div class="rightsidebarTitle">附件</div>
					<div class="rightsidebarbox">
						<div class="rightsidebarbox1">
							<div v-for='(i,index) in nametype' :key="index" 
								 :class="{'ait':index==typeindex}" @click="qiehuan(index)">
								 {{i.name}}
							 </div>
						</div>
					</div>
					<div class="rightsidebarImgbox">
						<rightsidebarImg :list="sidebarImg" :lexing="typeindex"></rightsidebarImg>
					</div>
				</div>
				
				<div class="rightsidebar2" style="margin:20px 0px;" v-if="datails.status==5">
					<div class="rightsidebarTitle">评价</div>
					<div style="display:flex;justify-content:center;">
						<el-rate v-model="rateValue"  :disabled="readonly" @change="onChange"></el-rate>
					</div>
					<p style="text-align: center;" v-if="datails.demand_score<1">请点击星星进行评分（1星最低分，5星最高）</p>
					<p style="text-align: center;" v-if="datails.demand_score==1">很糟糕</p>
					<p style="text-align: center;" v-if="datails.demand_score==2">较差</p>
					<p style="text-align: center;" v-if="datails.demand_score==3">一般</p>
					<p style="text-align: center;" v-if="datails.demand_score==4">还可以</p>
					<p style="text-align: center;" v-if="datails.demand_score==5">五星好评</p>
				</div>

			</div>
		</div>
		<el-dialog
		  title="开票"
		  :visible.sync="centerDialogVisible"
		  :close-on-click-modal="false"
		  width="430px"
		  >
		  <div>
			  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				  <el-form-item label="公司信息" prop="company_name">
					<el-input v-model="ruleForm.company_name"></el-input>
				  </el-form-item>
				  <el-form-item label="公司税号" prop="tax_id">
					<el-input v-model="ruleForm.tax_id"></el-input>
				  </el-form-item>
				  <el-form-item label="发票金额">
				  	 <el-input v-model="invoice_price" disabled></el-input>
				  </el-form-item>
				  <el-form-item label="邮箱信息" prop="email">
				  	<el-input v-model="ruleForm.email"></el-input>
				  </el-form-item>
				</el-form>
		  </div>
		  <span slot="footer" class="dialog-footer" style="display:flex;justify-content:center;">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="支付方式"
		  :visible.sync="payDialogVisible"
		  :close-on-click-modal="false"
		  width="750px"
		  >
		  <div>
			  <div class="pay-tip"><h3>扫码支付</h3><span>打开手机端微信APP扫一扫支付</span></div>
			  <div class="pay-box">
				  <LinkQrCode :link="payLink" :size="120" />
				  <div class="pay-box1">
					  <p  style="width:100%;">剩余支付时间：<CountDown :endTime="datails.auto_cancel_time*1000"></CountDown></p>
					  <h4 style="width:100%;">支付金额</h4>
					  <div class="pay-box3" style="width:100%;">
						  <span>￥{{datails.total_price}}</span>
						  <div class="pay-box4">
							  <img src="@/assets/wxpay.png" alt="" />
							  <p>微信支付</p>
						  </div>
					  </div>
				  </div>
			  </div>
			  
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import { 
		OrderDetail,
		invoicePrice,
		InvoiceApply,
		personal,
		OrderStageConfirm,
		OrderRating,
		payStatus,
		OrderPay
	} from "@/api/api.js"
	import LinkQrCode from '@/common/LinkQrCode.vue'
	import rightsidebarImg from '@/common/rightsidebarImg.vue'
	import CountDown from '@/common/CountDown.vue'
	export default {
	  name: 'HelloWorld',
	  components:{
		rightsidebarImg, 
		CountDown,
		LinkQrCode,
	  },
	  data() {
	    return {
		    nametype:[
				{name:"承认图"},
				{name:"生产图"}
			],
			typeindex:0,
			datails:{
				demand: {},
				demandUser: {},
				serveUser: {},
				stageOne: {},
				stageTwo: {}
			},
			rateValue:"",
			readonly:false,
			sidebarImg:[],
			invoice_price:"",
			centerDialogVisible:false,
			payDialogVisible:false,
			ruleForm:{
			   company_name: '',
			   tax_id:'',
			   email:"",
			},
			oId:"",
			user:"",
			rules: {
				 company_name: [
				   { required: true, message: '请输入公司信息', trigger: 'blur' },
				 ],
				 tax_id: [
				   { required: true, message: '请输入公司税号', trigger: 'blur' }
				 ],
				 email: [
				   { required: true, message: '邮件不能为空', trigger: 'blur' }
				 ],
			},
			rateValue:"",
			payLink:"",
			paybox:""
	    }
	  },
	  watch: {
	  		payDialogVisible(val) {
	  			if (!val) {
	  				this.clearPayTimer()
	  			}
	  		}
	  },
	  computed: {
			oid() {
			  return this.$route.query.oid || ''
			}
	  },
	  mounted() {
	     this.getdatails()
	  },
	  methods: {
		fanhui(){
		  	this.$router.go(-1);   
		},
		normalizeFileList(files){
			if (Array.isArray(files)) return files
			if (!files) return []
			if (typeof files === 'object') {
				const values = Object.values(files).filter(Boolean)
				return values.length ? values : [files]
			}
			return []
		},
		// 立即支付
		//支付
		pay(i){
			this.paybox=i
			OrderPay({
				order_sn:this.datails.order_sn,
				pay_type:'NATIVE'
			}).then(res=>{
				const payLink = res.data.data.code_url
				if (!payLink) {
					this.$message.error('未获取到支付链接')
					return
				}
				this.payLink = payLink
				this.payDialogVisible = true
				this.setpayStatus(this.paybox)
			})
		},
		clearPayTimer(){
			if (this.payTimer) {
				clearInterval(this.payTimer)
				this.payTimer = null
			}
		},
		// 支付轮询
		setpayStatus(e){
			console.log(this.datails.order_sn)
			this.clearPayTimer()
			this.payTimer = setInterval(() => {
				payStatus({
					order_sn:this.datails.order_sn,
					order_type:"1"
				}).then(res=>{
					if (this.isPaySuccess(res.data)) {
						this.$message.success('支付成功')
						this.payDialogVisible = false
						this.clearPayTimer()
						this.getdatails()
						this.$emit('gengxin',"0")
					}
				})
			}, 2000)
		},
		
		isPaySuccess(res){
			const data = res && res.data ? res.data : {}
			const payload = data || {}
			return res.status === 200 && payload.paid === 1
		},

		onChange(e) {
		  	OrderRating(this.datails.o_id,{
		  		score:this.rateValue
		  	}).then(res=>{
		  		if(res.data.status==200){
		  			this.$message.success('评价成功');
		  			this.getdatails()
		  		}
		  	})
		},
		chakan(){
			const targetPath = '/demandHome/demandOrder/Reviewdatails?oid='+this.oid
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		addpshen(){
			let that=this;
			this.$confirm('评审介入环节存在图纸信息泄露的潜在风险。您确定要发起评审吗？', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
			}).then(() => {
				  that.pingshen()
			}).catch(() => {
				         
			});  
		},
		pingshen(){
			let osid=""
			if(this.datails.status==2){
				osid=this.datails.stageOne.os_id
			}
			if(this.datails.status==4){
				osid=this.datails.stageTwo.os_id
			}
			if (this.$route.path !== '/demandHome/demandOrder/InitiateReview?os_id='+osid) {
				this.$router.push('/demandHome/demandOrder/InitiateReview?os_id='+osid)
			}
		},
		
		//确认验收
		yanshou(){
			let that=this;
			 this.$confirm('确认验收后，不可发起评审。您确定验收吗？', '提示', {
			 	  confirmButtonText: '确定',
			 	  cancelButtonText: '取消',
			 	  type: 'warning'
			 }).then(() => {
			 	  that.setConfirm()
			 }).catch(() => {
			 	         
			 });   
			  
		},
		setConfirm(){
			//承诺图待验收
			let yanshou=''
			if(this.datails.status==2){
				yanshou=this.datails.stageOne.os_id
			}
			//生产图待验收
			if(this.datails.status==4){
				yanshou=this.datails.stageTwo.os_id
			}
			OrderStageConfirm(yanshou,{
				
			}).then(res=>{
				if(res.data.status==200){
					this.$message.success('验收成功');
				    this.getdatails()
				}
			})
		},
		liuyan(o_id, status) {
			if (this.$route.path !== '/demandHome/demandOrder/AddMessage') {
				this.$router.push({
					path: '/demandHome/demandOrder/AddMessage',
					query: {
						oid: o_id,
						status: status
					}
				})
			}
		},
		kaipiao(e){
			this.oId=e
			this.getpersonal()
			this.getinvoicePrice()
			this.centerDialogVisible=true  
		},
		// 查看开票
		chakana(e){
			const targetPath = '/demandHome/demandOrder/orderInvoice?oid='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		getinvoicePrice(){
		  	invoicePrice(this.oId,{}).then(res=>{
		  		this.invoice_price=res.data.data.invoice_price
		  	})
		},
		// 添加开票
		submitForm(formName){
			this.$refs[formName].validate((valid) => {
				console.log(valid)
				if (valid) {
					this.submit()
				} else {
					return false;
				}
			});
		},
		submit(){
			InvoiceApply(this.oId,{
				...this.ruleForm
			}).then(res=>{
				if(res.data.status==200){
					this.$message.success('提交成功');
					this.centerDialogVisible=false  
					this.getdatails()
				}else{
					this.$message.success(res.data.msg);
				}
			})  
		},
		getpersonal(){
			personal({}).then(res=>{
				this.user=res.data.data
				this.ruleForm.company_name=this.user.company_name
				this.ruleForm.tax_id=this.user.tax_id
				this.ruleForm.email=this.user.email
			})
		},
		getdatails(){
			OrderDetail(this.oid,{}).then(res=>{
				const rawData = (res && res.data && res.data.data) || {}
				this.datails = {
					...rawData,
					demand: rawData.demand || {},
					demandUser: rawData.demandUser || {},
					serveUser: rawData.serveUser || {},
					stageOne: rawData.stageOne || {},
					stageTwo: rawData.stageTwo || {}
				}
				const stageOneFiles = this.datails.stageOne && this.datails.stageOne.files
				this.sidebarImg = this.normalizeFileList(stageOneFiles)
				this.sidebarImg.forEach(item=>{
					item.type=this.getFileType(item.file)
				})
				if(parseInt(this.datails.demand_score)>0){
					this.rateValue=parseInt(this.datails.demand_score)
					this.readonly=true
				}
				
			})
		},
		qiehuan(index){
			this.sidebarImg=[]
			this.typeindex=index
			if(this.typeindex==0){
				const stageOneFiles = this.datails && this.datails.stageOne && this.datails.stageOne.files
				this.sidebarImg = this.normalizeFileList(stageOneFiles)
			}else{
				const stageTwoFiles = this.datails && this.datails.stageTwo && this.datails.stageTwo.files
				this.sidebarImg = this.normalizeFileList(stageTwoFiles)
			}
			this.sidebarImg.forEach(item=>{
				item.type=this.getFileType(item.file)
			})
		},
		getFileType(url) {
		  const extension = url.split('.').pop().toLowerCase();
		  const typeMap = {
			'jpg': 'image',
			'jpeg': 'image',
			'png': 'image',
			'gif': 'image',
			'zip': 'zip',
			'rar': 'zip',
			'pdf': 'pdf'  ,// 根据实际需求可调整
			
		  };
		  return typeMap[extension] || 'unknown';
		},
		
		
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.container{
		width:1200px;
		margin: 0 auto;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebar{
		width:790px;
	}
	.rightsidebar{
		width:384px;
	}
	.leftsidebarTitle{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
	}
	.leftsidebarTitle span{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.leftsidebarDox{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebarDox1 h3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.leftsidebarDox1_1{
		width:200px;
		display:flex;
		align-items: center;
		margin-top:12px;
	}
	.leftsidebarDox1_1 img{
		width: 32px;
		height: 32px;
		margin-right:12px;
		border-radius:50%;
	}
	.leftsidebarDox1_1 div{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
	}
	.leftsidebarDox2 h3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.leftsidebarDox2 div{
		font-weight: bold;
		font-size: 24px;
		color: #FF5900;
		margin-top:15px;
	}
	.rightsidebar1{
		width:100%;
		height: 108px;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		display:flex;
		justify-content:center;
		flex-wrap:wrap;
		flex-direction: column;
		text-align:center;
		margin-bottom:24px;
	}
	.rightsidebar1 h3{
		text-align:center;
		width:100%;
	}
	.rightsidebar1 p{
		color:#FF5900;
	}
	.rightsidebar2{
		width:100%;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		padding:20px;
		box-sizing: border-box;
	}
	.rightsidebarbox{
		width:100%;
		display:flex;
		align-items: center;
		justify-content:center;
		margin-top:12px;
	}
	.rightsidebarbox1{
		width: 220px;
		height: 46px;
		background: #1E3A8A;
		border-radius: 26px 26px 26px 26px;
		border: 1px solid #FFFFFF;
		opacity: 0.6;
		padding:7px 12px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.rightsidebarbox1 div{
		width:94px;
		height:32px;
		line-height:32px;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
		display: flex;
		text-align: center;
		justify-content: center;
		cursor:pointer;
	}
	.ait{
		background: #FFFFFF;
		border-radius: 16px;
		border: 1px solid #1E3A8A;
		color: #1E3A8A !important;
	}
	.rightsidebarAdd{
		width:100%;
		height: 44px;
		background: #FFFFFF;
		display:flex;
		justify-content: center;
		align-items: center;
		border:1px dashed  #1E3A8A;
		border-radius:8px;
		margin-top:12px;
		cursor:pointer;
	}
	.rightsidebarAdd img{
		width:16px;
		height:16px;
		margin-right:5px;
	}
	.rightsidebarAdd span{
		font-weight: 400;
		font-size: 14px;
		color: #1E3A8A;
	}
	.rightsidebarImgbox p{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		margin-top:12px;
	}
	.leftsidebarButton{
		width:100%;
		display:flex;
		align-items:center;
		justify-content:flex-end;
		margin-top:30px;
	}
	.leftsidebar2{
		padding:5px 15px;
		box-sizing: border-box;
		background: rgba(30,58,138,0.15);
		border-radius: 8px;
		display:flex;
		justify-content:center;
		align-items: center;
		font-weight: 500;
		font-size: 14px;
		color: #1E3A8A;
		margin-left:10px;
		cursor: pointer;
	}
	::v-deep .el-rate{
		height:36px;
	}
	::v-deep .el-rate__icon{
		font-size:28px;
	}
	.pay-tip{
		margin-top: 12px;
		text-align: left;
		color: #666;
		font-size: 14px;
		display:flex;
		align-items: center;
		margin-top:15px;
	}
	.pay-tip h3{
		font-weight: bold;
		font-size: 19rpx;
		color: #333333;
		margin-right:10px;
	}
	.pay-tip span{
		font-weight: 400;
		font-size: 13rpx;
		color: #666666;
	}
	.pay-box{
		width:100%;
		height:120px;
		display:flex;
		margin-top:10px;
	} 
	.pay-box1{
		margin-left:24px;
		display: flex;
		justify-content:space-between;
		align-items: center;
		flex-wrap: wrap;
	}
	.pay-box1 p{
		color: #FF5900;
	}
	/* .pay-box2{
		margin-top:30px;
	} */
	.pay-box1 h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.pay-box3 span{
		font-weight: 800;
		font-size: 24px;
		color: #FF5900;
	}
	.pay-box3{
		display:flex;
		align-items: center;
	}
	.pay-box4{
		width:146px;
		height:42px;
	    display:flex;
		align-items: center;
		justify-content: center;
		background: #FFFFFF;
		border-radius: 12px;
		border: 1px solid #4DC800;
		margin-left:30px;
	}
	.pay-box4 img{
		width:20px;
		height:18px;
		margin-right:10px;
	}
	.pay-box4 p{
		font-weight: 400;
		font-size: 16px;
		color: #333333;
	}
</style>